import React, { useState } from 'react';
import {
  Typography, Paper, TextField, Button, Box
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import API_URL from '../../settings';
import { useAuth } from '../../context/AuthContext';

function EventCreate() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    title: '',
    description: '',
    event_date: ''
  });
  const { user } = useAuth();


  const handleSubmit = async () => {
    const res = await fetch(`${API_URL}/events`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...form,
        hospital_id: user.hospital_id,
        created_at: new Date().toISOString()
      })
    });

    const event = await res.json();

    // 👉 ผูกผู้สูงอายุทุกคนเข้า event
    const patients = await fetch(`${API_URL}/patients?hospital_id=${user.hospital_id}`).then(r => r.json());

    await Promise.all(
      patients.map(p =>
        fetch(`${API_URL}/event_recipients`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            event_id: event.id,
            patient_id: p.id,
            patient_name: p.first_name + ' ' + p.last_name,
            volunteer_id: p.volunteer_id,
            received: false
          })
        })
      )
    );

    navigate('/events');
  };

  return (
    <Paper sx={{ p: 3, maxWidth: 600 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        สร้าง Event แจกของ
      </Typography>

      <TextField
        fullWidth
        label="ชื่อกิจกรรม"
        sx={{ mb: 2 }}
        value={form.title}
        onChange={e => setForm({ ...form, title: e.target.value })}
      />

      <TextField
        fullWidth
        label="รายละเอียด"
        multiline
        rows={3}
        sx={{ mb: 2 }}
        value={form.description}
        onChange={e => setForm({ ...form, description: e.target.value })}
      />

      <TextField
        fullWidth
        type="date"
        label="วันที่จัด"
        InputLabelProps={{ shrink: true }}
        sx={{ mb: 3 }}
        value={form.event_date}
        onChange={e => setForm({ ...form, event_date: e.target.value })}
      />

      <Button variant="contained" onClick={handleSubmit}>
        บันทึก Event
      </Button>
    </Paper>
  );
}

export default EventCreate;
